
        import 'next/dist/esm/server/web/globals'
        import { adapter } from 'next/dist/esm/server/web/adapter'
        import * as _mod from "private-next-root-dir/src/middleware.jsx"

        const mod = { ..._mod }
        const handler = mod.middleware || mod.default

        if (typeof handler !== 'function') {
          throw new Error('The Middleware "pages/src/middleware" must export a `middleware` or a `default` function');
        }

        export default function (opts) {
          return adapter({
            ...opts,
            page: "/src/middleware",
            handler,
          })
        }
    